import React from 'react';
import { Checkbox } from 'antd';
import { CheckboxValueType } from 'antd/es/checkbox/Group';
import styled from 'styled-components';

import { FormFieldLabel } from './FormFieldLabel';
import { StyledFormItem } from './FormInput';

export type FormCheckboxGroupProps = {
  name: string;
  label?: string;
  options: string[];
  vertical?: boolean;
  required?: boolean;
  onChange?: (checkedValue: CheckboxValueType[]) => void;
};

const StyledCheckboxGroupVertical = styled(StyledFormItem)`
  .ant-checkbox-wrapper {
    margin-inline-start: 0px;
    margin-left: 8px;
    margin-bottom: 5px;
  }

  .ant-checkbox-wrapper:last-of-type {
    margin-bottom: 0px;
  }

  .ant-checkbox-group {
    flex-direction: column;
  }
`;

const StyledCheckboxGroup = styled(StyledFormItem)`
  .ant-checkbox-group {
    flex-direction: row;
  }

  .ant-select-selector {
    height: 2.64rem;
  }

  .ant-select-selection-item {
    height: 2rem;
    align-items: center;
  }

  .ant-row {
    flex-direction: row;
  }

  .ant-form-item-label {
    display: flex;
    align-content: center;
  }

  .ant-form-item-control {
    width: auto !important;
    margin-left: 10px;
  }
`;

const StyledCheckbox = styled(Checkbox.Group)`
  .ant-checkbox-inner,
  .ant-checkbox-input {
    transform: scale(1.25);
  }
`;

export const FormCheckboxGroup: React.FC<FormCheckboxGroupProps> = ({
  name,
  label,
  options,
  vertical,
  required,
  onChange,
}) => {
  const labelItem = label ? <FormFieldLabel required={required}>{label}</FormFieldLabel> : null;
  return (
    <>
      {vertical ? (
        <StyledCheckboxGroupVertical name={name} label={labelItem}>
          <StyledCheckbox options={options} onChange={onChange} />
        </StyledCheckboxGroupVertical>
      ) : (
        <StyledCheckboxGroup name={name} label={labelItem}>
          <StyledCheckbox options={options} onChange={onChange} />
        </StyledCheckboxGroup>
      )}
    </>
  );
};
